import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propChildren, propShape, } from '../../../../../helpers/custom-prop-types';
const Select2MultipleInputOnlyLabelFieldRender = (props) => {
    const { children, innerProps } = props;
    return _jsx("div", Object.assign({}, innerProps, { children: children }));
};
Select2MultipleInputOnlyLabelFieldRender.propTypes = {
    children: propChildren().isRequired,
    innerProps: propShape().isRequired,
};
export default Select2MultipleInputOnlyLabelFieldRender;
